import {connect} from "react-redux";
import React, {useMemo, useRef, useState} from "react";
import {CAlert, CButton, CCol, CForm, CFormInput, CFormSelect, CInputGroup, CInputGroupText} from "@coreui/react";
import {Loading} from "../../../components/common";
import StoreCornerListWhere from "../where/StoreCornerListWhere";
import locale from "antd/es/date-picker/locale/ko_KR";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import * as o2Api from "../../../api/api";
import * as formatter from "../../../config/formatter";
import * as XLSX from "xlsx";

const HandleProductStoreCorner = (props) => {
	const gridRef = useRef();
	const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
	const {user} = props.account;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({visible: false, message: ""});
  const [gridData, setGridData] = useState([]);
  const [searchForm, setSearchForm] = useState({
    cmpCd: "", brandCd: "", storeCd: "", cornerCd: ""
  });
  const [selectList, setSelectList] = useState([]);
  const fileRef = useRef();

  const defaultColDef = {
    width: 100,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeaderHeight: true
  };

  const [columnDefs] = useState([
    {
      field: "isUse",
      headerName: "사용\n여부", //No
      maxWidth: 120,
      headerCheckboxSelection: true,
      checkboxSelection: (params) => {
        return params.data.isUse === "Y" ? 'true' : 'false';
      },
      valueFormatter: (e) => {
        return e.data.isUse === "Y" ? "사용" : "미사용";
      }
    },
    {field: "restProductCd", headerName: "상품코드", maxWidth: 130},
    {field: "productNm", headerName: "상품명", width: 220},
    {field: "sourceCd", headerName: "바코드", flex: 1},
    {field: "supPrice", headerName: "원가"},
    {field: "price", headerName: "판매단가"},
    {field: "productDiv", headerName: "상품구분", valueGetter: (e) => { return e.data.productDiv === "1" ? "판매상품" : "주문상품" } },
    {field: "bagYn", headerName: "봉투사용여부"},
    {field: "bagPrice", headerName: "봉투금액"},
    {field: "updTime", headerName: "등록일시", width: 140 ,hide:true}
  ]);

	const handleSelect = (code, value) => {
		console.log("### code :: ", code, value);
		if (value === "C") {
			setSearchForm((state) => ({
				...state,
				cmpCd: code, brandCd: "", storeCd: "", cornerCd: ""
			}));
		} else if (value === "B") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: code, storeCd: "", cornerCd: ""
			}));
		} else if (value === "S") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: code, cornerCd: ""
			}));
		} else if (value === "O") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: state.storeCd, cornerCd: code
			}));
		}
	}

	const onCheck = (e) => {
		console.log("checked :: ", e);
	}

	const search = async () => {
		setError({
			visible: false,
			message: ""
		});

		const {cmpCd, brandCd, storeCd, cornerCd} = searchForm;
		console.log("### cornerCd :: ", cornerCd, cornerCd.length);
		if (cornerCd.length === 0) {
			setError({
				visible: true,
				message: "조회시 코너는 반드시 선택하셔야 합니다."
			});
			return;
		}

    // 조회 조건에 따라 분기
    setLoading(true);
    // cmpCd 는 필수
    const params = {
      cmpCd: cmpCd,
      brandCd: brandCd,
      storeCd: storeCd,
      cornerCd: cornerCd,
      productNm: searchForm.productNm,
      restProductCd: searchForm.restProductCd,
      barcode: searchForm.barcode,
      isUse: searchForm.isUse
    };
    const { data: result } = await o2Api.getProductByCorner(params);
    const { responseBody, responseCode, responseMessage } = result;
    if (responseCode === "200") {
      if (responseBody != null) {
        console.log('responseBody:: ', responseBody);
        setGridData(responseBody);
      }
    }
    setLoading(false);
  };

    //엑셀업로드
    const excelUploadBtnClick = () => {
        const {cmpCd, brandCd, storeCd, cornerCd} = searchForm;
        if (cornerCd.length === 0) {
            alert("코너를 선택해 주세요");
            return;
        }
        fileRef.current.click();
    }

    const clear = () => {
        if (fileRef.current) {
            fileRef.current.value = '';
        }
        setGridData([]);
    }

    const workbookToJson = (workbook) => {
        let jArray = [];
        workbook.SheetNames.forEach(function (sheetName) {
            const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {});
            if (roa.length > 0) jArray.push(roa);
        })
        return jArray[0];
    }

    const upload = (e) => {
        if (e.target.files?.item(0)) {
            const file = e.target.files[0];
            if (!getExtensionOfFilename(file)) {
                alert(".xlsx 확장자만 등록이 가능합니다.");
                clear();
                return;
            }

            clear();
            setLoading(true);
            readExcelFile(file, function (workBook) {
                const json = workbookToJson(workBook);
                console.log("json:: ", json);

                for (let i = 0; i < json.length; i++) {
                    //엑셀 결과값Json, Key값 변경 처리
                    //json[i].isUse = json[i].사용여부;
                    json[i].restProductCd = json[i].상품코드;
                    json[i].productNm = json[i].상품명;
                    //Key값 변경 후, 엑셀hearder Key값 삭제
                    //delete json[i].사용여부;
                    delete json[i].상품코드;
                    delete json[i].상품명;
                }

                setGridData(json);
                setLoading(false);
            })
        }
    }

    const readExcelFile = (file, callback) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = function (e) {
            const data = e.target?.result;
            console.log("data :: ", data);
            const workBook = XLSX.read(data, { type: "binary"});
            callback(workBook);
        }
    }

    const getExtensionOfFilename = (file) => {
        const filename = file.name;
        const _lastDot = filename.lastIndexOf('.');
        const _fileExt = filename.substr(_lastDot, filename.length).toLowerCase();

        return (_fileExt === '.xlsx' || _fileExt === '.xls');
    }
    //End 엑셀업로드

    //저장 시
    const save = async () => {
      const { api } = gridRef.current;
      if (api === null) return;

      const selectRows = api.getSelectedRows();
      if (selectRows.length === 0){
          alert("취급상품 [등록/삭제]할 행을 선택해 주세요.");
          return;
      }

      let useYn = "";
      if (selectRows[0].isUse === "Y") {
        useYn = "N";
      } else{
        useYn = "Y";
      }
      if(selectRows[0].productCd === "" || selectRows[0].productCd === null){
          useYn = "Y";
      }

      if (confirm("취급상품으로 등록/삭제 하시겠습니까?")) {
        const { cmpCd, brandCd, storeCd, cornerCd } = searchForm;
        const params = [];
        selectRows.map((item) => {
          const data = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            cornerCd: cornerCd,
            productCd: item.productCd,
            restProductCd: item.restProductCd,
            userId: user.userId,
            useYn: useYn
          };
          params.push(data);
        });
        console.log("코너 params : ", params);

        if(params[0].productCd === undefined || params[0].productCd === "" || params[0].productCd === null){
            //엑셀 업로드 저장 시
            const { data: result } = await o2Api.uploadProductStore(params);
            const { responseBody, responseCode, responseMessage } = result;

            if (responseCode === "200") {
                if (responseBody != null) {
                    alert("정상적으로 처리되었습니다.");
                    search();
                }
            }
        } else{
              //그리드에서 저장 시
              const { data: result } = await o2Api.updateProductStore(params);
              const { responseBody, responseCode, responseMessage } = result;

              if (responseCode === "200") {
                  if (responseBody != null) {
                      alert("정상적으로 처리되었습니다.");
                      search();
                  }
              }
          } //End else

      }
  };



    return (
      <>
        <div style={containerStyle}>
          {error.visible ? <CAlert color="danger" dismissible={true} onClose={() => { setError({visible: false, message: ""})}}>{error.message}</CAlert> : null}
          {loading ? <Loading/> : null}
          <CForm className={"row row-cols-lg-auto g-1 align-items-center"}>
            <StoreCornerListWhere type={"O"} account={props.account} selected={searchForm} onSelect={(c, v) => handleSelect(c, v)}/>
            <CCol xs={12}>
              <CInputGroup size={"sm"} className={"mb-1"}>
                <CInputGroupText style={{width: 80}}>상품코드</CInputGroupText>
                <CFormInput id="productCd"
                            style={{height: 35}}
                            onKeyPress={(e) => {
                              if (e.key === "Enter") {
                                search();
                              }
                            }}
                            onChange={(e) => {
                              setSearchForm((state) => ({
                                ...state,
                                restProductCd: e.target.value
                              }));
                            }}/>
              </CInputGroup>
            </CCol>
            <CCol xs={12}>
              <CInputGroup size={"sm"} className={"mb-1"}>
                <CInputGroupText style={{width: 80}}>상품명</CInputGroupText>
                <CFormInput id="productNm"
                            style={{height: 35}}
                            onKeyPress={(e) => {
                              if (e.key === "Enter") {
                                search();
                              }
                            }}
                            onChange={(e) => {
                              setSearchForm((state) => ({
                                ...state,
                                productNm: e.target.value
                              }));
                            }}/>
              </CInputGroup>
            </CCol>
            <CCol xs={12}>
              <CInputGroup size={"sm"} className={"mb-1"}>
                <CInputGroupText style={{width: 80}}>바코드</CInputGroupText>
                <CFormInput id="barcode"
                            style={{height: 35}}
                            onKeyPress={(e) => {
                              if (e.key === "Enter") {
                                search();
                              }
                            }}
                            onChange={(e) => {
                              setSearchForm((state) => ({
                                ...state,
                                barcode: e.target.value
                              }));
                            }}/>
              </CInputGroup>
            </CCol>
            <CCol xs={12}>
              <CInputGroup size={"sm"} className={"mb-1"}>
                <CInputGroupText style={{width: 80}}>사용유무</CInputGroupText>
                <CFormSelect onChange={(e) => {
                  setSearchForm((state) => ({
                    ...state,
                    isUse: e.target.value
                  }));
                }}>
                  <option value={""}>전체상품</option>
                  <option value={"Y"}>사용중</option>
                </CFormSelect>
              </CInputGroup>
            </CCol>
            <CCol xs={12}>
              <CButton size={"sm"} onClick={search}>조회</CButton>
              <CButton style={{marginLeft: 10}} size={"sm"} onClick={save}>저장</CButton>
              <CButton style={{marginLeft: 10}}  size={"sm"} onClick={excelUploadBtnClick}>엑셀업로드</CButton>
              <input type={"file"} accept={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"} ref={fileRef} style={{display: "none"}} onChange={upload}/>
            </CCol>
          </CForm>

          <div style={{height: 10}}/>
          <div className="ag-theme-alpine" style={{width: "100%", height: 500}}>
            <AgGridReact
                ref={gridRef}
                headerHeight={30}
                rowHeight={30}
                rowData={gridData}
                animateRows={true}
                pagination={true}
                defaultColDef={defaultColDef}
                columnDefs={columnDefs}
                rowSelection="multiple">
            </AgGridReact>
          </div>
        </div>
      </>
  )
}

const mapStateToProps = (state) => {
	const {account, store, selected} = state;
	return {
		account, store, selected
	};
};

export default connect(mapStateToProps, null)(HandleProductStoreCorner);
